<app-header [progress]="3" [title]="locale.currentTranslation.tripInformationHeader" data-testid="police-drug-test-header"></app-header>
<div class="base-content-container" data-testid="police-drug-test-container">
  <div class="headline3" data-testid="police-drug-test-title">{{ locale.currentTranslation.policeDrugTest1 }}
  </div>
  <div  style="display: flex; flex-direction: column; gap: 24px;" data-testid="radio-options">
    @for (option of options; track option) {
      <div class="radio-button-base" [attr.data-testid]="'radio-option-' + option.value">
        <div>
          <input type="radio"
            [value]="option.value"
            [formControl]="radioControl"
            [attr.data-testid]="'radio-input-' + option.value"
            [attr.aria-labelledby]="'radio-label-' + option.value">
        </div>
        <div (click)="setOption(option.value)" [attr.data-testid]="'radio-label-container-' + option.value">
          <div class="label1" [attr.id]="'radio-label-' + option.value" [attr.data-testid]="'radio-headline-' + option.value">{{ option.headline}}</div>
          <div class="caption1" [attr.data-testid]="'radio-caption-' + option.value">{{ option.caption }}</div>
        </div>
      </div>
    }
  </div>
  @if (showError) {
    <div class="caption1 error-text" data-testid="validation-error" role="alert">
      {{ locale.currentTranslation.errorMessageUserInputNotChosen }}
    </div>
  }
</div>
<div class="main-button-spacing">
  <button class="main-button" (click)="nextClicked()" data-testid="btn-next" role="button" tabindex="0">{{ locale.currentTranslation.next }}</button>
</div>
<app-footer data-testid="police-drug-test-footer"></app-footer>
